import React from 'react';

export default function Footer() {
  return (
    <footer style={{
      background: '#ffffff',
      borderTop: '3px solid var(--blue)',
      padding: '2.5rem 4rem',
      display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', flexWrap: 'wrap', gap: '1.5rem',
    }}>
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
        <img src="/rigomich-logo.png" alt="Rigomich Logo" style={{ width: 52, height: 52, objectFit: 'contain' }} />
        <div>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: '0.95rem', color: '#0d2144', letterSpacing: '0.08em', textTransform: 'uppercase' }}>Rigomich Integrated Company Limited</div>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.52rem', fontWeight: 400, letterSpacing: '0.22em', color: '#1a4f9c', textTransform: 'uppercase', marginTop: 2 }}>RC: 700638 � Est. 2007 � Nigeria</div>
        </div>
      </div>

      {/* Links */}
      <ul style={{ display: 'flex', gap: '2rem', listStyle: 'none' }}>
        {['#about', '#services', '#projects', '#contact'].map((href, i) => (
          <li key={i}>
            <a href={href} style={{
              fontFamily: "'Barlow Condensed', sans-serif",
              fontSize: '0.78rem', fontWeight: 600,
              letterSpacing: '0.1em', textTransform: 'uppercase',
              color: '#0d2144', textDecoration: 'none', transition: 'color 0.2s',
            }}
            onMouseEnter={e => e.currentTarget.style.color = 'var(--blue)'}
            onMouseLeave={e => e.currentTarget.style.color = '#0d2144'}>
              {href.replace('#', '')}
            </a>
          </li>
        ))}
      </ul>

      {/* Copyright */}
      <div style={{ fontSize: '0.7rem', color: '#0d2144', fontWeight: 300 }}>
        � {new Date().getFullYear()} Rigomich Integrated Company Limited. All rights reserved.
      </div>

      <style>{`
        @media (max-width: 900px) {
          footer { flex-direction: column; text-align: center; padding: 2rem 1.5rem; }
          footer ul { justify-content: center; flex-wrap: wrap; gap: 1rem; }
        }
      `}</style>
    </footer>
  );
}